import * as ExcelJs from "exceljs";
import { jwtDecode } from "jwt-decode";
import moment from "moment";

export const updateObject = (oldObject, updatedProperties) => {
  return {
    ...oldObject,
    ...updatedProperties,
  };
};

export const getChipColorByEtatCode = (etatCode) => {
  switch (etatCode) {
    case "NOU":
      return "primary";
    case "ANN":
    case "CLO":
    case "ENV":
    case "1":
    case "7":
      return "warning";
    case "2":
    case "SVM":
    case "SVM(Avispartiel)":
    case "SVM(Avistotal)":
    case "SVM(TranfertEffectue)":
    case "24":
      return "info";
    case "EAA":
    case "ACCADII":
    case "MOD":
    case "3":
    case "5":
    case "VISA":
    case "9":
      return "success";
    case "REJADII":
    case "REJ":
    case "EAD":
    case "6":
    case "8":
    case "12":
    case "RECM":
    case "21":
      return "error";
    case "SMM":
    case "SMM(Avispartiel)":
    case "SMM(Avistotal)":
    case "SMM(TranfertEffectue)":
    case "4":
      return "info";
    case "SMD":
    case "SMA":
    case "10":
    case "11":
      return "info";
    default:
      return "primary";
  }
};

export const getChipColorByEtatCodeTi = (etatCode) => {
  switch (etatCode) {
    case "ALT":
      return "primary";
    case "RECB":
    case "RECM":
    case "RECA":
    case "REC":
    case "PDRF":
    case "DRF":
    case "ANRF":
    case "CRBA":
    case "RERF":
    case "RDDCE":
    case "REJADII":
      return "error";
    case "CON":
    case "CMCE":
    case "CBNQ":
    case "DOM":
    case "PDOM":
    case "ACCEPTADII":
    case "CBNA":
      return "success";
    case "DFIN":
    case "VISA":
    case "ECHU":
    case "REGLP":
    case "DOM_SOUMI_BAN":
    case "DOM_SOUMI_ADII":
    case "ECHU_SOUM_PROL":
      return "warning";
    case "APUR":
    case "FINA":
    case "CAN":
    case "MOD":
    case "REP":
    case "DOM_MODIF":
    case "REGL":
    case "SOUMI_MOD_DCE":
    case "SOUMI_MOD_ADII":
    case "ENVADII":
    case "ENV":
      return "info";
    default:
      return "primary";
  }
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toISOString();
};

export function recursiveFormatDate(dateString) {
  if (!dateString) return null;

  const formattedDate = new Date(dateString);

  return formattedDate;
}

export function recursiveFormatDateTI(dateString) {
  if (!dateString) return null;

  const FinDateParts = dateString?.split("/");
  dateString = `${FinDateParts[2]}/${FinDateParts[1]}/${FinDateParts[0]}`;
  const formattedDate = new Date(dateString);

  return formattedDate;
}

export const formattedDateFromDB = (dateString) => {
  const date = new Date(dateString);

  const formattedDate = date.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  return formattedDate;
};

export const formattedDateTimeFromDB = (dateString) => {
  if (dateString === null) return null;

  const date = new Date(dateString);

  const formattedDate = date.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  const time = date.toLocaleTimeString("fr-FR", {
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
  });

  const result = `${formattedDate} ${time}`;

  return result;
};

export const formateDateToISO = (dateString) => {
  const [datePart, timePart] = dateString.split(" ");
  const [day, month, year] = datePart.split("/");

  const date = new Date(`${year}-${month}-${day}T${timePart}:00`);

  return date.toISOString();
};

export const ImportDemandes = (rows) => {
  const workBook = new ExcelJs.Workbook();
  const sheet = workBook.addWorksheet("Demandes");
  sheet.properties.defaultRowHeight = 16;

  sheet.columns = [
    {
      header: "Catégorie",
      key: "categorie",
      width: 20,
    },
    {
      header: "Importateur",
      key: "importateur",
      width: 20,
    },
    {
      header: "Année",
      key: "annee",
      width: 10,
    },
    {
      header: "N° du regitre du commerce",
      key: "numRC",
      width: 35,
    },
    {
      header: "N° d'enregistrement PortNet",
      key: "numEenregistrementPortnet",
      width: 35,
    },
    {
      header: "Valeur FOB",
      key: "valeurFOB",
      width: 20,
    },
    {
      header: "Devise",
      key: "devise",
      width: 20,
    },
    {
      header: "Poids accordée en Kgs",
      key: "poidsAccorde",
      width: 25,
    },
    {
      header: "Valeur imputée",
      key: "valeurImpute",
      width: 19,
    },
    {
      header: "Poids imputé",
      key: "poidsImpute",
      width: 19,
    },
    {
      header: "Unité",
      key: "unite",
      width: 10,
    },
    {
      header: "Pays Origine",
      key: "paysOrigine",
      width: 20,
    },
    {
      header: "Nomenclature douanière",
      key: "nomenclatureDouaniere",
      width: 30,
    },
    {
      header: "designation commerciale de la marchandise",
      key: "designationCommMarch",
      width: 45,
    },
    {
      header: "Bureau de Dédouannement",
      key: "bureauDedouannement",
      width: 30,
    },
    {
      header: "Adresse",
      key: "adresse",
      width: 25,
    },
    {
      header: "EMAIL",
      key: "email",
      width: 25,
    },
    {
      header: "Contact",
      key: "contact",
      width: 20,
    },
  ];

  const headerRow = sheet.getRow(1);
  headerRow.eachCell((cell, number) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "25384a" },
    };
    cell.font = {
      family: 4,
      size: 12,
      bold: true,
      color: { argb: "FFFFFF" },
    };
  });

  sheet.views = [{ state: "frozen", ySplit: 1 }];

  rows.map((row) => {
    sheet.addRow({
      categorie: row?.typeDFD.description,
      importateur: row?.operatorImp?.description,
      annee: moment(row?.createdDt).year(),
      numRC: row?.operatorImp?.numeroRc,
      numEenregistrementPortnet: row?.number,
      valeurFOB: row?.merchandise?.montantFOB,
      devise: row?.merchandise?.currency?.description,
      poidsAccorde: row?.merchandise.netWeight,
      valeurImpute: row?.merchandise?.marchandiseImputees[0]?.montant,
      poidsImpute: row?.merchandise?.marchandiseImputees[0]?.quantite,
      unite: row?.merchandise?.unitCustoms?.description,
      paysOrigine: row?.merchandise?.paysorigine?.description,
      nomenclatureDouaniere: row?.merchandise?.typeNomenclature?.code,
      designationCommMarch: row?.merchandise?.designationCommerciale,
      bureauDedouannement: row?.customOffice?.description,
      adresse: row?.adressExpediter,
      email: row?.operatorImp?.email,
      contact: row?.operatorImp?.telMobile,
    });
  });

  workBook.xlsx.writeBuffer().then((data) => {
    const blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.speadsheet.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = "Demandes(DFD).xlsx";
    anchor.click();
    window.URL.revokeObjectURL(url);
  });
};

export const ExportLicences = (rows) => {
  const workBook = new ExcelJs.Workbook();
  const sheet = workBook.addWorksheet("Licences");
  sheet.properties.defaultRowHeight = 16;

  sheet.columns = [
    {
      header: "Nº d’enregistrement",
      key: "numEnrg",
      width: 22,
    },
    {
      header: "Date de création",
      key: "dateDebut",
      width: 18,
    },
    {
      header: "Catégorie de la licence",
      key: "categorie",
      width: 25,
    },
    {
      header: "Devise",
      key: "devise",
      width: 30,
    },
    {
      header: "Montant total en devise",
      key: "montant",
      width: 23,
    },
    {
      header: "Bureau douanier",
      key: "bureauD",
      width: 25,
    },
    {
      header: "Exportateur",
      key: "exportateur",
      width: 25,
    },
    {
      header: "Déclarant",
      key: "declarant",
      width: 18,
    },
    {
      header: "Etat",
      key: "etat",
      width: 28,
    },
    {
      header: "Pays Destination",
      key: "paysDest",
      width: 25,
    },
    {
      header: "Ville Exportateur",
      key: "villeExp",
      width: 18,
    },
  ];

  const headerRow = sheet.getRow(1);
  headerRow.eachCell((cell, number) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "25384a" },
    };
    cell.font = {
      family: 4,
      size: 12,
      bold: true,
      color: { argb: "FFFFFF" },
    };
  });

  sheet.views = [{ state: "frozen", ySplit: 1 }];

  rows.map((row) => {
    const paysDestinationArray = row?.origcountry?.map((origcount) => {
      return origcount?.nationality?.description;
    });
    sheet.addRow({
      numEnrg: row?.numRegistre,
      dateDebut: formattedDateTimeFromDB(row?.registrationDate),
      categorie: row?.exportTitleType?.code,
      devise: row?.currencyType?.description,
      montant: row?.totalQuantity.toString(),
      bureauD: row?.customsOffice?.description,
      exportateur: row?.operatorImpExp?.description,
      declarant: row?.freightForwarder?.description,
      etat: row?.typeStateTitleExp?.description,
      paysDest: paysDestinationArray ? paysDestinationArray.join(", ") : "",
      villeExp: row?.operatorImpExp?.ville?.description,
    });
  });

  workBook.xlsx.writeBuffer().then((data) => {
    const blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.speadsheet.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = "Licences(LE).xlsx";
    anchor.click();
    window.URL.revokeObjectURL(url);
  });
};

export const ExportTitres = (rows) => {
  const workBook = new ExcelJs.Workbook();
  const sheet = workBook.addWorksheet("Titres");
  sheet.properties.defaultRowHeight = 16;

  sheet.columns = [
    {
      header: "Nº d’enregistrement",
      key: "numEnrg",
      width: 25,
    },
    {
      header: "Date de création",
      key: "dateDebut",
      width: 18,
    },
    {
      header: "Catégorie du titre",
      key: "categorie",
      width: 20,
    },
    {
      header: "Devise",
      key: "devise",
      width: 25,
    },
    {
      header: "Montant total en devise",
      key: "montant",
      width: 23,
    },
    {
      header: "Importateur",
      key: "importateur",
      width: 25,
    },
    {
      header: "Déclarant",
      key: "declarant",
      width: 18,
    },
    {
      header: "Banque",
      key: "banque",
      width: 25,
    },
    {
      header: "Etat",
      key: "etat",
      width: 28,
    },
  ];

  const headerRow = sheet.getRow(1);
  headerRow.eachCell((cell, number) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "25384a" },
    };
    cell.font = {
      family: 4,
      size: 12,
      bold: true,
      color: { argb: "FFFFFF" },
    };
  });

  sheet.views = [{ state: "frozen", ySplit: 1 }];

  rows.map((row) => {
    sheet.addRow({
      numEnrg: row?.numEnregistrement?.toString(),
      dateDebut: formattedDateTimeFromDB(row?.dateEnregistrement)?.toString(),
      categorie: row?.typeTitreImportation?.code?.toString(),
      devise: row?.typeDevise?.description?.toString(),
      montant: parseFloat(row?.montantTotal).toFixed(2)?.toString(),
      importateur:
        row?.operateurImportateurExportateur?.description?.toString(),
      declarant: row?.transitaire?.description?.toString(),
      banque: row?.banqueDescription?.toString(),
      etat: row?.etatDescription?.toString(),
    });
  });

  workBook.xlsx.writeBuffer().then((data) => {
    const blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.speadsheet.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = "Titres(TI).xlsx";
    anchor.click();
    window.URL.revokeObjectURL(url);
  });
};

export const getAuth = () => {
  let Auth;
  const token = localStorage.getItem("token");
  if (token) {
    const decoded = jwtDecode(token);
    if (
      decoded.roles.includes(
        "ROLE_VUPORTUARIA_MEAD",
        "ROLE_VUPORTUARIA_COMPAGNIE_AERIENNE",
        "ROLE_VUPORTUARIA_ADMIN",
        "ROLE_VUPORTUARIA_OPERADOR"
      )
    ) {
      Auth = decoded;
    }
  } else {
    return null;
  }
  return Auth;
};

export const preparePayloadEtatTable = (columnsState, density, module) => {
  const activatedFields = Object.entries(columnsState)
    .filter(([key, value]) => value)
    .map(([key]) => key)
    .join(",");

  return {
    activatedField: activatedFields,
    density: density,
    module: module,
  };
};

export const getRoles = () => {
  const token = localStorage.getItem("token");
  let roles = [];
  if (token) {
    const decoded = jwtDecode(token);
    roles = decoded?.roles?.filter((role) =>
      [
        "ROLE_VUPORTUARIA_MEAD",
        "ROLE_VUPORTUARIA_COMPAGNIE_AERIENNE",
        "ROLE_VUPORTUARIA_ADMIN",
        "ROLE_VUPORTUARIA_FREIGHT_FORWARDER",
        "ROLE_VUPORTUARIA_OPERADOR",
        "ROLE_VUPORTUARIA_FACTURAS_CLIENTE",
        "ROLE_VUPORTUARIA_FACTURAS_EMISOR",
      ].includes(role)
    );

    const factureRoles = [
      "ROLE_VUPORTUARIA_FACTURAS_CLIENTE",
      "ROLE_VUPORTUARIA_FACTURAS_EMISOR",
    ];

    roles = roles.sort((leftRole, rightRole) => {
      const leftIsFactureRole = factureRoles.includes(leftRole);
      const rightIsFactureRole = factureRoles.includes(rightRole);

      if (leftIsFactureRole === rightIsFactureRole) {
        return 0;
      }

      return leftIsFactureRole ? 1 : -1;
    });
  }
  return roles;
};

export const hasAnyRole = (roles) => {
  const token = localStorage.getItem("token");
  if (!token) {
    return false;
  }

  try {
    const decodedToken = jwtDecode(token);
    const userRoles = decodedToken.roles;
    const hasMatchingRole = roles.some((role) => userRoles.includes(role));
    return hasMatchingRole;
  } catch (error) {
    return false;
  }
};

export const roleBasedOrder = {
  ROLE_VUPORTUARIA_MEAD: [
    "Achat de Forfait",
    "Opération d'importation",
    "Avis d'arrivée",
    "Manifeste",
    "Bon à délivrer Maritime",
    "Gestion Bon de sortie",
    "Visite et contrôle",
    "Main levée",
    "Opération d'Exportation",
    "Souscription des navires",
    "Portnet's KPI",
  ],
  ROLE_VUPORTUARIA_COMPAGNIE_AERIENNE: [
    "Achat de Forfait",
    "Manifeste Aérien",
    "Terminal",
    "EDIFACT",
    "Portnet's KPI",
  ],
  ROLE_VUPORTUARIA_ADMIN: [
    "Achat de Forfait",
    "Opération d'importation",
    "Opération d'Exportation",
    "Manifeste Aérien",
    "Terminal",
    "EDIFACT",
    "Portnet's KPI",
  ],
  ROLE_VUPORTUARIA_FREIGHT_FORWARDER: [
    "Avis d'arrivéeFF",
    "TerminalFF",
    "Importation FF",
    "Exportation FF",
    "Paramétrage FF",
    "Factures FF",
  ],
  ROLE_VUPORTUARIA_OPERADOR: [
    "Achat de Forfait",
    "TerminalOperateur",
    "Douane",
    "Gestion des Escales",
    "ConsultationsOM",
    "Synthèse journalière",
    "Portnet's KPI",
    "Factures",
  ],
  ROLE_VUPORTUARIA_FACTURAS_CLIENTE: ["Factures"],
  ROLE_VUPORTUARIA_FACTURAS_EMISOR: ["Factures"],
};
